import { Component, OnInit } from '@angular/core';
import { FechasService } from 'src/app/services/fechas/fechas';
import { FormGroup, FormControl } from '@angular/forms';
import { MessageService, SelectItem } from 'primeng/api';
import { PitufoService } from 'src/app/services/pesos/pitufo';
import { Location } from '@angular/common';
import { UserLoginService } from 'src/app/services/UserLogin/userLoginService';
import { StorageManager } from 'src/app/common/storage-manager.class';
import { Router } from '@angular/router';
import { VariedadesService } from 'src/app/services/variedades/variedades';
import { EmailService } from 'src/app/services/email/emailService';
import { UploadService } from 'src/app/services/upload/upload.service';


@Component({
  selector: 'app-pesos',
  templateUrl: './pesos.component.html',
  styleUrls: ['./pesos.component.css'],
  providers: [FechasService, MessageService, PitufoService, UserLoginService, VariedadesService]
})
export class PesosCreateComponent implements OnInit {
  public items = {
    "maquina": "",
    "cliente": "",
    "responsable": "",
    "fecha": "",
    "hora": "",
    "variedad": "",
    "pesos": "",
    "confecccion": "",
    "id_etiqueta": "",
    "observaciones": "",
    "global_gap": false,
    "IGP": false,
    "prod_integrado": false,
    "residuo": false,

  };
  public pesos: any[] = [];
  public myConfeccion: string = "2.5";
  public variedades: SelectItem[] = [];
  public selectedVariedad: any;
  public variedad = "";
  public myClient: string = "-";
  public myResponable: string = "";
  public MyHour: any = this.hora();
  public fecha: Date = new Date(this.fechasService.fechaActual());
  public MyWeight: string = "";
  public MyMachine: string = "4";
  public id_etiqueta: string = "";
  public observaciones: string = "";
  public contador = 0;
  public pesosForm: FormGroup;
  public archivo = '';
  public product: any = { fecha: "", nombre: "", hora: "", peso: "" };
  public es = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    today: 'Hoy',
    clear: 'Borrar'
  };
  public uploadedFiles: any[] = [];
  public file:File;
  public imgURL: any="https://via.placeholder.com/150/808080/FFFFFF?Text=Digital.com";
  public imagePath = '';

  public user: any;
  message: string;
  public global_gap: boolean = false;
  public IGP: boolean = false;
  public prod_integrado: boolean = false;
  public residuo: boolean = false;
  
  constructor(
    private fechasService: FechasService,
    private messageService: MessageService,
    private pitufo: PitufoService,
    private location: Location,
    private variedadesService: VariedadesService,
    private router: Router,
    private emailService: EmailService,
    private UploadService: UploadService

  ) {
    this.user = StorageManager.getUser();

  }

  ngOnInit() {
    this.myResponable = this.user.name;

    this.variedades.push({ label: 'Selecciona variedad', value: null });
    this.variedadesService.listVariedad().toPromise().then((data: any) => {
      //console.log(data);
      for (let index = 0; index < data.length; index++) {
        const element = { label: data[index].nombre, value: data[index].nombre };
        this.variedades.push(element);

      }
      //console.log(this.variedades);

    }).catch( error =>{
      console.log("Error", error);
    });
  }
  poner() {
    if (this.MyWeight == "") {
      this.messageService.add({ severity: 'error', summary: 'Error Peso', detail: 'El campo de peso tiene que contener algún valor' });
    } else {
      let myArray = new info(this.fecha, this.MyHour, this.MyMachine, this.MyWeight);

      this.pesos.push(myArray.peso);
      this.MyWeight = "";
    }

  }

  hora() {
    let fecha = new Date();
    let hora = "" + fecha.getHours();
    let min = "" + fecha.getMinutes();
    if (fecha.getHours() < 10) {
      hora = "0" + hora;
    }

    if (fecha.getMinutes() < 10) {
      min = "0" + min;
    }
    let myHour = hora + ":" + min;

    return myHour;
  }


  uploadFile(event){

    this.file = event.target.files[0];
    let files = event.target.files;
    let numb=this.file.name.lastIndexOf(".");
    if (files.length === 0)
    return;

  var mimeType = files[0].type;
  if (mimeType.match(/image\/*/) == null) {
    this.message = "Only images are supported.";
    this.messageService.add({severity:'error', summary: 'Error', detail:'Las extensiones de las imágenes permitidias son jpg,jpeg,png'});
    return;
  }
  if(mimeType.localeCompare('image/bmp')  == 0 ) {
    this.archivo = '';
    this.file = null;
    this.messageService.add({severity:'error', summary: 'Error', detail:'Las extensiones de las imágenes permitidias son jpg,jpeg,png'});
    return;
  }

  var reader = new FileReader();
  this.imagePath = files;
  reader.readAsDataURL(files[0]); 
  reader.onload = (_event) => { 
    this.imgURL = reader.result; 
  }
  /* uploadFile(event){
    //console.log(event.target.files);
    //let file:File=event.target.files[0];
    this.file=event.target.files[0];
    console.log(event.target.files);
    let numb=this.file.name.lastIndexOf(".");
    let subExt=this.file.name.substring(numb);
    //console.log("ext ",subExt);


       
      } */
    }

  enviar() {
    if (this.myClient == "" || this.myConfeccion == "" || this.variedad == "") {
      // console.log(this.MyWeight, this.myClient, this.myConfeccion, this.variedad)
      // this.messageService.add({severity:'error', summary: 'Error ', detail:'Todos los Campos tienen que tener algún valor'});

    } else {
      let nuevosPesos = "";
      for (let index = 0; index < this.pesos.length; index++) {
        nuevosPesos = nuevosPesos + "" + this.pesos[index] + ";";

      }

      let fechaFix = this.fechaArreglada(this.fecha);
      this.items = {
        "maquina": this.MyMachine,
        "cliente": this.myClient,
        "responsable": this.myResponable,
        "fecha": fechaFix,
        "hora": this.MyHour,
        "variedad": this.variedad,
        "pesos": nuevosPesos,
        "confecccion": this.myConfeccion,
        "id_etiqueta": this.id_etiqueta,
        "observaciones": this.observaciones,
        "global_gap": this.global_gap,
        "IGP": this.IGP,
        "prod_integrado": this.prod_integrado,
        "residuo": this.residuo,
        
      }
      this.pitufo.create(this.items).subscribe((resp: any) => {
        // console.log("RESP",resp);
        let id = resp.id;
        if(this.file != null) {
          this.UploadService.uploadFilesPesosPitufo(this.file, id).toPromise()
          .then( resp => {

          })
          .catch( error => {
            console.log("error file", error);
            
          });
        }
        this.messageService.add({ severity: 'success', summary: 'Registro', detail: 'Registro Añadido Correctamente' });
        this.MyMachine = "";
        this.myClient = "";
        this.variedad = "";
        this.pesos = [];
        this.myConfeccion = "";
        let observaciones: string = this.items.observaciones;
      
        if(observaciones === null || observaciones === undefined || observaciones.length == 0 ){
  
        } else {
          this.emailService.sendMessage( this.items,'PESOS PITUFO').toPromise().then(data =>{
            //console.log('data', data);
           
          }).catch( error => {
            console.log('error message', error);
          });
        }
        setTimeout(() => {
          this.router.navigate(['dashboard/pesos']);
        }, 1000)
      }, error => {
        console.log("Error", error);
      });


    }

  }

  fechaActual() {
    let today = new Date();
    let dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    let DD = "";
    let MM = "";
    if (dd < 10) {
      DD = "0" + dd;
    } else {
      DD = "" + dd;
    }

    if (mm < 10) {
      MM = "0" + mm;
    } else {
      MM = "" + mm;
    }

    let myfecha = MM + '/' + DD + '/' + yyyy;
    myfecha = yyyy + '-' + MM + '-' + DD;
    //console.log(myfecha);
    return myfecha;
  }

  fechaArreglada(fecha) {

    let today = new Date(fecha);
    let dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    let DD = "";
    let MM = "";
    if (dd < 10) {
      DD = "0" + dd;
    } else {
      DD = "" + dd;
    }

    if (mm < 10) {
      MM = "0" + mm;
    } else {
      MM = "" + mm;
    }

    let myfecha = MM + '/' + DD + '/' + yyyy;
    myfecha = yyyy + '-' + MM + '-' + DD;
    return myfecha;
  }


  Regresar() {
    this.location.back();
  }
  delete(index) {
    // console.log(this.pesos);
    
    this.pesos.splice(index,1);
    // console.log(this.pesos);
  }

}


class info {
  fecha: string;
  hora: string;
  maquina: string;
  peso: String;

  constructor(fecha, hora, maquina, peso) {
    this.fecha = fecha;
    this.hora = hora;
    this.maquina = maquina;
    this.peso = peso;
  }


}